import Vue from 'vue';
import Router from 'vue-router';
import store from './store';
Vue.use(Router);
const routes = [{
  path: '*',
  redirect: '/index',
  meta: {
    keepAlive: true,
    pageTitle: '假日伙伴',
  }
},
{
  path: '/LoginLocal',
  name: 'LoginLocal',
  component: () => import('./components/LoginLocal.vue'),
  meta: {
    pageTitle: '本地登录'
  }
},
{
  path: '/logout',
  name: 'logout',
  component: () => import('./components/logout.vue'),
  meta: {
    pageTitle: '退出账户'
  }
},
{
  path: '/wxOpen',
  name: 'wxOpen',
  component: () => import('./components/wxOpen.vue'),
  meta: {
    pageTitle: '提示'
  }
},
{
  path: '/reg',
  name: 'reg',
  component: () => import('./components/reg.vue'),
  meta: {
    pageTitle: '注册'
  }
},
{
  path: '/WxLogin',
  name: 'WxLogin',
  component: () => import('./components/WxLogin.vue'),
  meta: {
    pageTitle: '登录'
  }
},
// ---------------------------------首页
{
  path: '/',
  name: 'index',
  component: () => import('./components/index/index.vue'),
  meta: {
    keepAlive: true,
    isBack: false,
    pageTitle: '假日伙伴'
  }
},
{
  path: '/pages/detail/detail',
  name: 'detail',
  component: () => import('./components/detail/detail.vue'),
  meta: {
    pageTitle: '活动详情'
  }
},
{
  path: '/filter',
  name: 'filter',
  component: () => import('./components/filter/filter.vue'),
  meta: {
    keepAlive: true,
    isBack: false,
    pageTitle: '活动'
  }
},
// ---------------------------------------------已申请
{
  path: '/application',
  name: 'application',
  component: () => import('./components/application/application.vue'),
  meta: {
    keepAlive: true,
    isBack: false,
    requireAuth: true,
    pageTitle: '已申请'
  }
},
// ----------------------------------------------我的任务
{
  path: '/task',
  name: 'task',
  component: () => import('./components/task/task.vue'),
  meta: {
    keepAlive: true,
    isBack: false,
    requireAuth: true,
    pageTitle: '我的任务'
  }
},
{
  path: '/subPackages/myTask/taskDetail', // 里面有任务,孩子,异常
  name: 'taskDetail',
  component: () => import('./components/subPackages/myTask/taskDetail.vue'),
  meta: {
    keepAlive: false,
    isBack: false,
    pageTitle: '任务详情'
  }
},
{
  path: '/subPackages/myTask/taskDetail2', // 里面有任务,异常
  name: 'taskDetail2',
  component: () => import('./components/subPackages/myTask/taskDetail2.vue'),
  meta: {
    keepAlive: false,
    isBack: false,
    pageTitle: '任务详情'
  }
},
{
  path: '/subPackages/myTask/taskRelationship',
  name: 'taskRelationship',
  component: () => import('./components/subPackages/myTask/taskRelationship.vue'),
  meta: {
    keepAlive: false,
    isBack: false,
    pageTitle: '组织关系'
  }
},
{
  path: '/subPackages/myTask/taskRelationshipVip',
  name: 'taskRelationshipVip',
  component: () => import('./components/subPackages/myTask/taskRelationshipVip.vue'),
  meta: {
    keepAlive: false,
    isBack: false,
    pageTitle: '营长查看'
  }
},

{
  path: '/subPackages/myTask/upload',
  name: 'myTaskUpload',
  component: () => import('./components/subPackages/myTask/upload.vue'),
  meta: {
    keepAlive: false,
    isBack: false,
    pageTitle: '上传图片'
  }
},
{
  path: '/subPackages/myTask/comment',
  name: 'myTaskComment',
  component: () => import('./components/subPackages/myTask/comment.vue'),
  meta: {
    keepAlive: false,
    isBack: false,
    pageTitle: '评价信息'
  }
},
// ----------------------------------------------个人中心
{
  path: '/center',
  name: 'center',
  component: () => import('./components/center/center.vue'),
  meta: {
    keepAlive: false,
    isBack: false,
    requireAuth: true,
    pageTitle: '个人中心'
  }
},
{
  path: '/subPackages/myCenter/examList',
  name: 'centerExamList',
  component: () => import('./components/subPackages/myCenter/examList.vue'),
  meta: {
    keepAlive: false,
    isBack: false,
    requireAuth: true,
    pageTitle: '考卷'
  }
},
{
  path: '/subPackages/myCenter/exam',
  name: 'centerExam',
  component: () => import('./components/subPackages/myCenter/exam.vue'),
  meta: {
    keepAlive: false,
    isBack: false,
    requireAuth: true,
    pageTitle: '试卷'
  }
},
{
  path: '/styles',
  name: 'styles',
  component: () => import('./components/styles/styles.vue'),
  meta: {
    keepAlive: true,
    isBack: false,
    requireAuth: false,
    pageTitle: '假日伙伴风采'
  }
},
{
  path: '/subPackages/myCenter/myFavor',
  name: 'centerMyFavor',
  component: () => import('./components/subPackages/myCenter/myFavor.vue'),
  meta: {
    keepAlive: true,
    isBack: false,
    pageTitle: '我的收藏'
  }
},
{
  path: '/subPackages/myCenter/personInfor',
  name: 'centerPersonInfor',
  component: () => import('./components/subPackages/myCenter/personInfor.vue'),
  meta: {
    pageTitle: '个人信息'
  }
},
{
  path: '/subPackages/myCenter/personalPhoto',
  name: 'centerPersonalPhoto',
  component: () => import('./components/subPackages/myCenter/personalPhoto.vue'),
  meta: {
    pageTitle: '个人近照'
  }
},
{
  path: '/subPackages/myCenter/personalExperience',
  name: 'centerPersonalExperience',
  component: () => import('./components/subPackages/myCenter/personalExperience.vue'),
  meta: {
    pageTitle: '个人经历'
  }
},
{
  path: '/subPackages/myCenter/bank',
  name: 'centerBank',
  component: () => import('./components/subPackages/myCenter/bank.vue'),
  meta: {
    pageTitle: '银行账户'
  }
},
{
  path: '/subPackages/myCenter/exam',
  name: 'centerExam',
  component: () => import('./components/subPackages/myCenter/exam.vue'),
  meta: {
    pageTitle: '考试'
  }
},
{
  path: '/subPackages/myCenter/searchMoney',
  name: 'centerSearchMoney',
  component: () => import('./components/subPackages/myCenter/searchMoney.vue'),
  meta: {
    pageTitle: '薪资查询'
  }
},
{
  path: '/subPackages/myCenter/chooseCity',
  name: 'chooseCity',
  component: () => import('./components/subPackages/myCenter/chooseCity.vue'),
  meta: {
    pageTitle: '站点切换'
  }
},
{
  path: '/subPackages/myCenter/file',
  name: 'myCenterFile',
  component: () => import('./components/subPackages/myCenter/file.vue'),
  meta: {
    requireAuth: true,
    isBack: false,
    pageTitle: '课程资料'
  }
},
{
  path: '/subPackages/myCenter/playVideo',
  name: 'myCenterPlayVideo',
  component: () => import('./components/subPackages/myCenter/playVideo.vue'),
  meta: {
    pageTitle: '播放视频'
  }
},
{
  path: '/subPackages/myCenter/serviceInformation',
  name: 'centerServiceInformation',
  component: () => import('./components/subPackages/myCenter/serviceInformation.vue'),
  meta: {
    pageTitle: '客服'
  }
},
{
  path: '/subPackages/myCenter/helpCenter',
  name: 'centerHelpCenter',
  component: () => import('./components/subPackages/myCenter/helpCenter.vue'),
  meta: {
    pageTitle: '帮助中心'
  }
},
{
  path: '/Position',
  name: 'position',
  component: () => import('./components/Position/index.vue'),
  meta: {
    keepAlive: true,
    pageTitle: '岗位'
  }
},
{
  path: '/posSeach',
  name: 'posSeach',
  component: () => import('./components/Position/component/posSeach.vue'),
  meta: {
    keepAlive: true,
    pageTitle: '拼音搜索'
  }
},
{
  path: '/grouping',
  name: 'grouping',
  component: () => import('./components/Position/component/grouping.vue'),
  meta: {
    pageTitle: '调整分组'
  }
},
{
  path: '/posDetail',
  name: 'posdetail',
  component: () => import('./components/Position/component/posDetail.vue'),
  meta: {
    pageTitle: '大队信息'
  }
},

{
  path: '/lochus',
  name: 'lochus',
  component: () => import('./components/Position/component/lochus.vue'),
  meta: {
    pageTitle: '中队信息'
  }
},
{
  path: '/camper',
  name: 'camper',
  component: () => import('./components/Position/component/camper.vue'),
  meta: {
    pageTitle: '小队信息'
  }
},
{
  path: '/physicalState',
  name: 'physicalState',
  component: () => import('./components/Position/component/physicalState.vue'),
  meta: {
    // keepAlive: true,
    pageTitle: '体温/排便'
  }
},
{
  path: '/abnormal',
  name: 'abnormal',
  component: () => import('./components/Position/component/abnormal.vue'),
  meta: {
    pageTitle: '异常信息'
  }
},
{
  path: '/abnormalDetail',
  name: 'abnormalDetail',
  component: () => import('./components/Position/component/abnormalDetail.vue'),
  meta: {
    pageTitle: '异常详情'
  }
},
{
  path: '/abnormalSearch',
  name: 'abnormalSearch',
  component: () => import('./components/Position/component/abnormalSearch.vue'),
  meta: {
    pageTitle: '异常列表'
  }
},
{
  path: '/errorPage',
  name: 'errorPage',
  component: () => import('./components/404.vue'),
  meta: {
    pageTitle: '出错了'
  }
},
{
  path: '/itemSearch',
  name: 'itemSearch',
  component: () => import('./components/Position/component/itemSearch.vue'),
  meta: {
    pageTitle: '搜索'
  }
},
{
  path: '/teamControl',
  name: 'teamControl',
  component: () => import('./components/Position/control/teamControl.vue'),
  meta: {
    pageTitle: '管理'
  }
},
{
  path: '/partnerAdmin',
  name: 'partnerAdmin',
  component: () => import('./components/Position/control/partnerAdmin.vue'),
  meta: {
    pageTitle: '伙伴管理'
  }
},
{
  path: '/registerPeople',
  name: 'registerPeople',
  component: () => import('./components/Position/control/registerPeople.vue'),
  meta: {
    pageTitle: '录入伙伴'
  }

},
{
  path: '/batchInputPeople',
  name: 'batchInputPeople',
  component: () => import('./components/Position/control/batchInputPeople.vue'),
  meta: {
    pageTitle: '批量录入伙伴'
  }

},
{
  path: '/groupsAdmin',
  name: 'groupsAdmin',
  component: () => import('./components/Position/control/groupsAdmin.vue'),
  meta: {
    pageTitle: '队伍管理'
  }
},
{
  path: '/integral',
  name: 'integral',
  component: () => import('./components/subPackages/myCenter/integral.vue'),
  meta: {
    pageTitle: '积分明细'
  }
},

{
  path: '/work',
  name: 'work',
  component: () => import('./components/Position/component/work.vue'),
  meta: {
    pageTitle: '工作人员'
  }
},
{
  path: '/tuozhuai',
  name: 'tuozhuai',
  component: () => import('./components/Position/component/tuozhuai.vue'),
  meta: {
    pageTitle: '拖拽测试'
  }
},
{
  path: '/sign',
  name: 'sign',
  component: () => import('./components/Position/component/sign.vue'),
  meta: {
    pageTitle: '签到'
  }
},
{
  path: '/maploading',
  name: 'mapLoading',
  component: () => import('./components/subPackages/myCenter/mapLoading.vue'),
  meta: {
    pageTitle: '地图'
  }
},
{
  path: '/footprinting',
  name: 'footprinting',
  component: () => import('./components/subPackages/myCenter/Footprinting.vue'),
  meta: {
    pageTitle: '活动库列表'
  }
},
{
  path: '/footprinting/detail',
  name: 'footprintingdetail',
  component: () => import('./components/subPackages/myCenter/footPrintingDetail.vue'),
  meta: {
    pageTitle: '详情'
  }
},
{
  path: '/footprinting/relevancy',
  name: 'footRelevancy',
  component: () => import('./components/subPackages/myCenter/fooTrelevancy.vue'),
  meta: {
    pageTitle: '活动关联'
  }
},
{
  path: '/footprinting/edit',
  name: 'footEdit',
  component: () => import('./components/subPackages/myCenter/footEdit.vue'),
  meta: {
    pageTitle: '更新踩点'
  }
}
];

// 页面刷新时，重新赋值token
console.log(' 页面刷新时，重新赋值token', localStorage.token)
if (localStorage.token) {
  store.commit('SET_TOKEN', localStorage.token);
};
if (localStorage.site) {
  store.commit('ChangeSite', localStorage.site);
};
if (localStorage.citys) {
  store.commit('SET_ALLSITE', localStorage.citys);
};
if (localStorage.info) {
  store.commit('SetInfo', localStorage.info);
};
const router = new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }

})

router.beforeEach((to, from, next) => {
  directRightUrl();
  //设置页面标题
  typeof to.meta.pageTitle !== undefined && setDocumentTitle(to.meta.pageTitle);
  //判断是否登录跳转
  if (to.matched.some(r => r.meta.requireAuth)) {
    // alert('需要权限判断');
    if (localStorage.token) {
      next();
    } else {
      if (to.fullPath.indexOf('/WxLogin') < 0) {
        localStorage.redirectUrl = to.fullPath;
        next({
          path: '/WxLogin'
        });
      } else {
        next({
          path: '/'
        });
      }

    }
  } else {
    // alert('不需要权限判断');
    next();
  }
})

let setDocumentTitle = function (title) {
  document.title = title;
  let ua = navigator.userAgent;
  if (/\bMicroMessenger\/([\d\.]+)/.test(ua) && /ip(hone|od|ad)/i.test(ua)) {
    var i = document.createElement('iframe');
    i.src = '/favicon.ico';
    i.style.display = 'none';
    i.onload = function () {
      setTimeout(function () {
        i.remove();
      }, 9);
    };
    document.body.appendChild(i);
  }
};


let directRightUrl = function () {
  let paths = window.location.href.split('#')
  paths[1] = paths[1] || '/'
  // 老式的#!分隔跳转
  if (paths[0].charAt(paths[0].length - 1) !== '?') {
    paths[0] = `${paths[0]}?`
  }
  if (paths[1].charAt(0) === '!') {
    paths[1] = paths[1].substr(1)
  }
  let url = `${paths[0]}#${paths[1]}`

  if (window.location.href !== url) {
    window.location.href = url
  }
};

export default router;